import util from '../util'

let controller = 'SolicitacaoMfaRetaguarda'
export default Object.assign({}, util.GetCrud(controller, null), {
    MudarSituacaoSolicitacao: function (dto) {
        return util.Axios.Put(controller, 'MudarSituacaoSolicitacao', dto)
    },
})
